/* globals $ */
(function() {
    'use strict';

    window.Matrix = {
        matrix_selector: '#matrix',
        button_selectors: {
            'next': '.matrix_next',
            'previous': '.matrix_previous'
        },

        max_step: 0,
        max_to_slide: 0,
        current_step: 1,

        window_width: 0,
        column_width: 0,

        slide_lock: false,

        init: function(params) {
            // override the default params
            for (var param_name in params) {
                if (typeof this[param_name] !== 'undefined') {
                    this[param_name] = params[param_name];
                }
            }

            // get the width of elements
            var num_columns = $(this.matrix_selector + ' .slider .matrix-column').length;
            var step_width = $(this.matrix_selector + ' .matrix-column:eq(0)').width();
            var slider_width = num_columns * step_width;
            this.window_width = $(this.matrix_selector + ' .matrix-middle:eq(0)').width();

            // get how many steps the slider will have
            this.max_step = Math.ceil(slider_width / this.window_width); //
            this.max_to_slide = slider_width - this.window_width;

            var parent = this;

            // apply css
            $(this.matrix_selector + ' .slider').css('width', slider_width + 'px');

            // apply the action buttons
            $(this.matrix_selector + ' ' + this.button_selectors.next).click(function() {
                parent.slide('next');
            });

            $(this.matrix_selector + ' ' + this.button_selectors.previous).click(function() {
                parent.slide('previous');
            });
        },

        slide: function(direction) {

            if (direction === 'next' && this.current_step === (this.max_step) ||
                direction === 'previous' && this.current_step === 1) {
                return;
            }

            if (direction === 'next') {
                this.current_step++;
            }
            else {
                this.current_step--;
            }

            var amount_to_slide = (this.current_step - 1) * (this.window_width);
            if (amount_to_slide > this.max_to_slide) {
                amount_to_slide = this.max_to_slide;
            }

            var parent = this;
            $('.slider').animate(
                {
                    'margin-left': (-1 * amount_to_slide) + 'px'
                },
                500,
                function() {
                    parent.slide_lock = false;
                }
            );
        }
    };
})();